<template>

    <tr :class="{ 'row-locked': rowDisabled }">
        <td class="premiere-colonne">
            <span v-once v-html="choice.label" class="premiere-colonne--fixed"></span>
            <!-- <span v-once v-html="choice.label" class="premiere-colonne- -runin"></span> -->
        </td>
        <td class="autres-colonnes" v-for="(column, index) of columns" :key="index" :class="{ 'col-locked': isColumnDisabled(column.id) }">
            <div class="choices" v-if="defaults.type === 'radiogroup'">
                <div class="radio" v-for="(choice, index) of defaults.choices" :key="index">
                    <radio-button-choice
                        :choice="choice"
                        :answer="getRowAnswerOnCol(column.id)"
                        :name="row + '-' + column.id"
                        :disabled="rowDisabled || isColumnDisabled(column.id)"
                        :read-only="readOnly"
                        :column="column.id"
                        :question-index="questionIndex"
                    ></radio-button-choice>
                </div>
            </div>
        </td>
    </tr>

</template>


<script>
import { isObject, isArray, isNil, has, includes } from 'lodash';
import { matrixRowMixin } from './mixins/matrix-row-mixin';
import { matrixColumnsMixin } from './mixins/matrix-columns-mixin';

export default {
    name: 'matrix-3d-col-sourced-row',

    mixins:[
        matrixRowMixin,
        matrixColumnsMixin,
    ],

    props: {
        defaults: Object,
    },

    methods: {
        changeValue(value, col)
        {
            this.$parent.changeValue(value, this.choice.row, col);
        },

        getRowAnswerOnCol(col)
        {
            if (isObject(this.rowAnswer) && has(this.rowAnswer, col))
            {
                return this.rowAnswer[col];
            }
            return null;
        },

        isSelected(columnValue)
        {
            if (isNil(this.rowAnswer))
            {
                return false;
            }
            return this.rowAnswer == columnValue;
        },

        isHidden(colValue)
        {
            if (has(this.choice, 'except') && isArray(this.choice.except))
            {
                return (includes(this.choice.except, colValue));
            }

            return false;
        },

    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/matrix-3d-col-sourced-row.vue